import {withPrefix} from 'gatsby';

export const createAssetUrl = (url) => withPrefix(url);
